(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.lasxControlReady === 'true') return;
    root.dataset.lasxControlReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lasx-control-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lasx-control-panel]'));
    var manifestUrl = root.dataset.manifestUrl;
    var releaseStatus = root.querySelector('[data-lasx-control-release-status]');
    var releaseVersion = root.querySelector('[data-lasx-control-release-version]');
    var releaseDetails = root.querySelector('[data-lasx-control-release-details]');
    var releaseAction = root.querySelector('[data-lasx-control-release-action]');

    function activate(id) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.lasxControlTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.lasxControlPanel !== id;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.lasxControlTab);
      });
    });

    function renderSoftware(stable) {
      var release = stable && stable.release;
      if (!release) {
        releaseStatus.textContent = 'FIRST SIGNED RELEASE PREPARING';
        releaseStatus.classList.add('lasx-control-center__state--preparing');
        releaseVersion.textContent = 'LASOUNDX Control';
        releaseDetails.textContent = 'The official page is online. The Windows download activates after the signed installer, checksum and release notes are published.';
        releaseAction.textContent = 'Preparing';
        releaseAction.removeAttribute('href');
        return;
      }

      releaseStatus.textContent = release.signatureVerified ? 'SIGNATURE VERIFIED' : 'VERIFICATION REQUIRED';
      releaseStatus.classList.toggle('lasx-control-center__state--preparing', !release.signatureVerified);
      releaseVersion.textContent = 'LASOUNDX Control ' + release.version;
      releaseDetails.textContent = [release.fileName, release.platform, release.sizeLabel, release.releaseDate].filter(Boolean).join(' / ');
      releaseAction.textContent = 'Download';
      releaseAction.href = release.fileUrl;
    }

    if (manifestUrl && window.fetch) {
      fetch(manifestUrl, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Manifest request failed: ' + response.status);
          return response.json();
        })
        .then(function (manifest) {
          renderSoftware(manifest && manifest.software && manifest.software.stable);
          root.dataset.manifestState = 'loaded';
        })
        .catch(function (error) {
          root.dataset.manifestState = 'unavailable';
          root.dataset.manifestError = error.message;
        });
    }

    activate('software');
  }

  document.querySelectorAll('[data-lasx-control-center]').forEach(initialize);
})();

